import useCustomerCountry from 'hooks/shared/useCustomerCountry';
import { useTranslation } from 'react-i18next';
import ReactMarkdown, { Components } from 'react-markdown';
import { WEBAPP_PEPPOL_PRESSEDLEARNMORE } from 'utils/amplitude/events/settings.amplitude';
import { Helper } from './Helper';
import type { FC, MouseEventHandler, JSX } from 'react';

const markdownComponents: Components = {
  a: ({ children, href }) => (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="underline"
    >
      {children}
    </a>
  ),
};

interface PeppolHelperProps {
  trigger?: (openModal: MouseEventHandler<HTMLButtonElement>) => JSX.Element;
}

const PeppolHelper: FC<PeppolHelperProps> = ({ trigger }) => {
  const { t } = useTranslation();
  const country = useCustomerCountry();
  return (
    <Helper tracingEvent={WEBAPP_PEPPOL_PRESSEDLEARNMORE} trigger={trigger}>
      <Helper.Title>{t('peppol.helper.intro_title')}</Helper.Title>
      <Helper.Paragraph>{t('peppol.helper.intro_text')}</Helper.Paragraph>
      <Helper.Title>{t('peppol.helper.title1')}</Helper.Title>
      <Helper.Paragraph>
        <ReactMarkdown>{t('peppol.helper.text1')}</ReactMarkdown>
      </Helper.Paragraph>
      <Helper.Title>{t('peppol.helper.title2')}</Helper.Title>
      <Helper.Paragraph>
        <ReactMarkdown>{t('peppol.helper.text2')}</ReactMarkdown>
      </Helper.Paragraph>
      <Helper.Paragraph>
        <ReactMarkdown components={markdownComponents}>
          {t('peppol.helper.blog.' + country)}
        </ReactMarkdown>
      </Helper.Paragraph>
      <Helper.Title>{t('peppol.helper.title3.' + country)}</Helper.Title>
      <Helper.Paragraph>
        <ul className="list-disc">
          <li>
            {t('peppol.helper.text3.p1.heading.' + country)}{' '}
            {t('peppol.helper.text3.p1')}
          </li>
          <li className="mt-2">
            {t('peppol.helper.text3.p2.heading.' + country)}{' '}
            {t('peppol.helper.text3.p2')}
          </li>
        </ul>
      </Helper.Paragraph>
    </Helper>
  );
};

export default PeppolHelper;
